var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"outer-wrapper"},[_c('el-carousel',{attrs:{"loop":"","height":"490px","autoplay":false}},_vm._l((_vm.items),function(item){return _c('el-carousel-item',{key:item},[_c('img',{staticClass:"img",attrs:{"src":item,"alt":""}})])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }